import UM from 'UM';
import $ from '$';
import {message} from 'antd';
import { isImgAndText } from '@/utils/common-tools';


//****************************************************************************************************getStem将各个部分拆出来，方便以后单独使用
function getContentStem(val,index,stemBlankIndex={stemBlankIndex:0},content = [],style,data,subNumber) {
    let innerString = ''
    if(data||data===''){
        if(val.indexOf('stem_after') > -1){//图后段落
            if(style[parseInt(val.split('_')[2])-1] == 0){//样式为空时
                if(subNumber){//子题的情况
                    message.error(`第${subNumber}题图后段落${val.split('_')[1]}样式不能为空！`);
                }else{
                    message.error(`图后段落${val.split('_')[1]}样式不能为空！`);
                }
                return content = false,false;
            }
            innerString = replaceCommonTags(data,stemBlankIndex);
        
            if(!innerString){
                if(subNumber){
                    message.error(`第${subNumber}题段落${val.split('_')[1]}内容不能为空！`);
                }else{
                    message.error(`段落${val.split('_')[1]}内容不能为空！`);
                }
                return content = false,false;
            }
            content.push(`#{"type":"para_begin","style":"${style[parseInt(val.split('_')[2])-1]}"}#${innerString}#{"type":"para_end"}#`);
        }else if(val.indexOf('stem') > -1){
            if(style[parseInt(val.split('_')[1])-1] == 0){
                if(subNumber){
                    message.error(`第${subNumber}题段落${val.split('_')[1]}样式不能为空！`);
                }else{
                    message.error(`段落${val.split('_')[1]}样式不能为空！`);
                }
                return content = false,false;
            }
            
            innerString = replaceCommonTags(data,stemBlankIndex);
            if(!innerString){
                if(subNumber){
                    message.error(`第${subNumber}题段落${val.split('_')[1]}内容不能为空！`);

                }else{
                    message.error(`段落${val.split('_')[1]}内容不能为空！`);
                }
                return content = false,false;
            }
            content.push(`#{"type":"para_begin","style":"${style[parseInt(val.split('_')[1])-1]}"}#${innerString}#{"type":"para_end"}#`);
        }
    }else{
    		//若是普通输入框
    		if(val.indexOf('textarea')!=-1){
    			 innerString = $(val).val();//img有没有id
    		}else{
    			innerString = UM.getEditor(val).getContent();//img有没有id
    		}
        
        content.push({[val]:innerString});
    }
    return content
}

//线索题解析
function getClueContentStem(val, index, stemBlankIndex = { stemBlankIndex: 0 }, content = [], style, data, subNumber) {
  let innerString = "",
    errmsg = "";
  if (data || data === "") {
    if (val.indexOf("stem_after") > -1) {
      //图后段落
      if (style[index] == 0) {
        //样式为空时
        if (subNumber) {
          //子题的情况
          message.error(`第${subNumber}题图后段落${index + 1}样式不能为空！`);
        } else {
          message.error(`图后段落${index + 1}样式不能为空！`);
        }
        return (content = false), false;
      }
      innerString = replaceCommonTags(data, stemBlankIndex);

      if (!innerString) {
        if (subNumber) {
          message.error(`第${subNumber}题段落${index + 1}内容不能为空！`);
        } else {
          message.error(`段落${val.split("_")[1]}内容不能为空！`);
        }
        return (content = false), false;
      }
      content.push(`#{"type":"para_begin","style":"${style[index]}"}#${innerString}#{"type":"para_end"}#`);
    } else if (val.indexOf("stem") > -1) {
      if (style[index] == 0) {
        if (subNumber) {
          message.error(`第${subNumber}题段落${index + 1}样式不能为空！`);
        } else {
          message.error(`段落${index + 1}样式不能为空！`);
        }
        return (content = false), false;
      }

      innerString = replaceCommonTags(data, stemBlankIndex);
      if (!innerString) {
        if (subNumber) {
          message.error(`第${subNumber}题段落${index + 1}内容不能为空！`);
        } else {
          message.error(`段落${index + 1}内容不能为空！`);
        }
        return (content = false), false;
      }
      let isValidContentRes = isImgAndText(data);
      let extractStyle = null;

      if (index > 0 && !isValidContentRes.isValide) {
        errmsg = `线索${index}内容不能同时存在图片和文本！`
        throw new Error(errmsg);
        //  return message.error(`线索${index}内容不能同时存在图片和文本！`);
      }
      if (index > 0) {
        extractStyle = isValidContentRes.hasImage ? "clue-item-img" : "clue-item-text";
        content.push(`#{"type":"para_begin","style":"${style[index]} ${extractStyle}"}#${innerString}#{"type":"para_end"}#`);
      } else {
        extractStyle = null;
        content.push(`#{"type":"para_begin","style":"${style[index]}"}#${innerString}#{"type":"para_end"}#`);
      }
    }
  } else {
    //若是普通输入框
    if (val.indexOf("textarea") != -1) {
      innerString = $(val).val(); //img有没有id
    } else {
      innerString = UM.getEditor(val).getContent(); //img有没有id
    }

    content.push({ [val]: innerString });
  }
//   return {
//     content,
//     errmsg
//   };
  return  content

}
function getContentAnswer(val,index,content,data,subNumber,answerType){
    let innerString = ''
    let isSpecialAnswer = ['subjectivityAnswer','spokenWordsAnswer','spokenPhrasesAnswer','spokenSentencesAnswer','spokenPassageAnswer','spokenPinyinAnswer','spokenPhoneticAnswer','semiOpenAnswer','spokenPassageCnAnswer','spokenPhrasesCnAnswer','spokenSentencesCnAnswer'].includes(answerType);
    if((data||data==='') && !isSpecialAnswer){
        innerString = replaceCommonTags(data);
     
        if(!innerString){
            if(subNumber){
                message.error(`第${subNumber}题答案${val.split('_')[1]}内容不能为空！`);
            }else{
                message.error(`答案${val.split('_')[1]}内容不能为空！`);
            }
            return content = false,false;
        }
        //过滤首尾#{"type":"P"}#
        let reg = /^#{"type":"P"}#*([^#{"type":"P"}#].*[^#{"type":"P"}#])#{"type":"P"}#*$/;
        innerString=innerString.replace(reg, "$1"); 
      
        content.push({blank_id:index+1,content:innerString});
    }else if(isSpecialAnswer ){
    		//主观题答案
    	if(data||data===''){
	        innerString = data||'';
	        innerString = replaceCommonTags(innerString,null,true);
	        content.push(innerString);
	    }else{
	        innerString = UM.getEditor(val).getContent()||'';
	        content.push({[val]:innerString});
	    }
    }else{
        innerString = UM.getEditor(val).getContent()
        content.push({[val]:innerString});

    }
    return content
}
function getContentImageAnswer(val,index,content,data,subNumber){
    let innerString = ''
    if(data||data===''){//子题的情况
        innerString = replaceCommonTags(data);
        if(!innerString){
            if(subNumber){
                message.error(`第${subNumber}题图片空${val.split('_')[1]}内容不能为空！`);

            }else{
                message.error(`图片空${val.split('_')[1]}内容不能为空！`);
            }
            return content = false,false;
        }
        content.push({blank_id:index+1,content:innerString});
    }else{
        innerString = UM.getEditor(val).getContent();
        content.push({[val]:innerString});

    }
    return content
}
function getContentExplain(val,index,content,data){
    let innerString = ''
    if(data||data===''){
        innerString = data||'';
        innerString = replaceCommonTags(innerString,null,true);
        content.push(innerString);
    }else{
        innerString = UM.getEditor(val).getContent()||'';
        content.push({[val]:innerString});
    }
    return content
}
function getContentOption(val,index,content,data,subNumber){
    let innerString = '';
    if(data||data===''){
        innerString = replaceCommonTags(data);
        if(!innerString){
            if(subNumber){
                message.error(`第${subNumber}题选项${val.split('_')[1]}内容不能为空！`);
            }else{
                message.error(`选项${val.split('_')[1]}内容不能为空！`);
            }
            return content = false,false;
        }
        //选项过滤首尾#type P
        let reg = /^#{"type":"P"}#*([^#{"type":"P"}#].*[^#{"type":"P"}#])#{"type":"P"}#*$/;
        innerString=innerString.replace(reg, "$1"); 
        content.push({code:val.charAt(val.length-1),item:innerString,question_item_id:0,item_origin:'',is_right:0});
    }else{
        //若是普通输入框
       
    		if(val.indexOf('textarea')>-1){
    			 innerString = $(val).val();//img有没有id
    		}else{
    			innerString = UM.getEditor(val).getContent();//img有没有id
    		}
        content.push({[val]:innerString});
    }
    return content
}
function dataConversion(str, value) { 
    let newStr = str.replace(/#{"type":"P"}#/g, '');
    let rules = [], rulesNoGroup = [], groupId = [], dataItem = {}, groups = [], groupItem = {};
    let reg = /[\s]*([+-×÷=]*)[\s]*<img class="blank_img_(\d+)" style="width: 38px; height: 20px" src="static\/img\/empty\/empty_(\d+)\.png"\/>/ig;
    let result = reg.exec(newStr);
    if (result == null) {
        message.error('格式不正确');
        return false;
    }
    while (result != null) {
        if (result[1] == '=') { // 等号分组
            groups.push({
                rules
            });
            rules = [];
            rules.push({
                op: '',
                blank: result[2],
            });
            
        }
        else {
            rules.push({
                op: result[1] || '',
                blank: result[2],
            });
        }
        
        result = reg.exec(newStr);
    }
    
    groups.push({
        rules
    });

    return {
        groups,
        result: value
    }
}
function getContentRule(val,index,content,data,subNumber,style){
    let innerString = '',innerItem;
    if(data||data===''){
        innerString = replaceCommonTags(data);
        if(!innerString){
            if(subNumber){
                message.error(`第${subNumber}题规则${index+1}内容不能为空！`);
            }else{
                message.error(`规则${index+1}内容不能为空！`);
            }
            return content = false,false;
        }
        innerItem = dataConversion(innerString, style[index].value);
        if (!innerItem) {
            return content = false,false;
        }

        content.push(innerItem);
    }else{
        innerString = UM.getEditor(val).getContent();
        content.push({[val]:innerString});
    }
    return content
}
function getContentForExplainTask(queue) {
    let content = [];
    queue.every(function (item,index) {
        let innerString = '';
        let str = UM.getEditor(item).getContent()||''
        innerString = replaceCommonTags(str,null,true);
        content.push(innerString);
    });

    return content;
}
//queue是要解析的editor的id数组 
function getContent(queue,style,indexBasics,isPreData,subNumber,questionType) {
    let content = [];
    let stemBlankIndex = {stemBlankIndex:0};
    if(indexBasics){//记录blankId用  图后段落的blankid有起始值
        stemBlankIndex.stemBlankIndex = indexBasics
    }
    queue && queue.every(function (item,index) {
        if(content){
            let data = false;
            let val = item;
            if(isPreData){val = Object.keys(item)[0];data= item[val];}
            let isClueQuestionType = false; //是否是线索题
            if(val.indexOf('question_stem') > -1 || val.indexOf('clue_stem') > -1){
                isClueQuestionType = true
            }
            if(val.indexOf('stem') > -1){
                if(isClueQuestionType){
                    content = getClueContentStem(val,index,stemBlankIndex,content,style,data,subNumber)
                }else{
                    content = getContentStem(val,index,stemBlankIndex,content,style,data,subNumber)
                }
            }else if (val.indexOf('imageAnswer') > -1) {
                content = getContentImageAnswer(val,index,content,data,subNumber)//图片答案
            } else if (val.indexOf('answer') > -1) {
                content = getContentAnswer(val,index,content,data,subNumber)//答案
            }else if (['subjectivityAnswer', 'spokenWordsAnswer', 'spokenPhrasesAnswer', 'spokenSentencesAnswer', 'spokenPassageAnswer','spokenPinyinAnswer','spokenPhoneticAnswer','semiOpenAnswer','spokenPassageCnAnswer','spokenPhrasesCnAnswer','spokenSentencesCnAnswer'].includes(val)) {
                content = getContentAnswer(val, index, content, data, subNumber, val); // 主观题答案
            }else if (val.indexOf('explain') > -1) {
                content = getContentExplain(val,index,content,data,subNumber)//解析
            }else if (val.indexOf('option') > -1) {
                content = getContentOption(val,index,content,data,subNumber)//选项
            }else if (val.indexOf('rule') > -1) { // 规则
                content = getContentRule(val,index,content,data,subNumber,style)
            }
            return true;
        }

    });
    return content;
}
function getContentClassify(val,index,type,dragOrItem='0',data) {
    let innerString = false
    if(data){//子题的情况
        innerString = UM.getEditor(val).getContent()
    }else{
        //判断大图还是文字
        if(type === '0'){

            let img = document.querySelector(`#${val} img`)
            let src = img.getAttribute('src'),
                width = img.getAttribute('width')||false,
                height = img.getAttribute('height')||false

            if(width==='pxundefined'||width==='px0'){width=false}
            if(height==='pxundefined'||height==='px0'){height=false}

            width = width&&width.replace(/px/ig,'')+'px'
            height = height&&height.replace(/px/ig,'')+'px'


            if(src&&src!==''){//如过没有width和height 就不加width属性

                if(width&&height){
                    innerString = `#{"type":"img","id":1,"src":"${src}","size":"big_category_image","width":"${width}","height":"${height}"}#`

                }else{
                    innerString = `#{"type":"img","id":1,"src":"${src}","size":"big_category_image"}#`

                }
            }
        }else{
            innerString = replaceCommonTags(UM.getEditor(val).getContent());
        }

    }

    return innerString
}
function getLigatureItems(items,hasdata) {
    let leftItems=[];
    let rightItems=[];
    for(let i = 0; i < items.leftLigature.number; i++){
        if(items.leftLigature.type[i] == 0){
            let img = document.querySelector(`#left_preview_${i+1} img`)
            if(!img){
                leftItems = false;
                return {leftItems:leftItems,rightItems:rightItems}
            }
            let src = img.getAttribute('src'),
                width = img.getAttribute('width')||false,
                height = img.getAttribute('height')||false

            if(width==='pxundefined'||width==='px0'){width=false}
            if(height==='pxundefined'||height==='px0'){height=false}

            width = width&&width.replace(/px/ig,'')+'px'
            height = height&&height.replace(/px/ig,'')+'px'

            if(width&&height){
                leftItems.push({content:`#{"type":"img","id":1,"src":"${src}","size":"big_match_image","width":"${width}","height":"${height}"}#`,id:i+1,style_type:0});

            }else{
                leftItems.push({content:`#{"type":"img","id":1,"src":"${src}","size":"big_match_image"}#`,id:i+1,style_type:0});
            }

        }else{
            let innerString
            if(hasdata){
                innerString = replaceCommonTags(items.leftLigature.content[i]);
            }else{
                innerString = replaceCommonTags(UM.getEditor(`ligature_left_${i+1}`).getContent());
            }

            if(!innerString){
                leftItems = false;
                return {leftItems:leftItems,rightItems:rightItems}
            }
            leftItems.push({content:innerString,id:i+1,style_type:1});
        }
    }
    for(let i = 0; i < items.rightLigature.number; i++){
        if(items.rightLigature.type[i] == 0){
            let img = document.querySelector(`#right_preview_${i+1} img`)
            if(!img){
                leftItems = false;
                return {leftItems:leftItems,rightItems:rightItems}
            }
            let src = img.getAttribute('src'),
                width = img.getAttribute('width')||false,
                height = img.getAttribute('height')||false

            if(width==='pxundefined'||width==='px0'){width=false}
            if(height==='pxundefined'||height==='px0'){height=false}

            width = width&&width.replace(/px/ig,'')+'px'
            height = height&&height.replace(/px/ig,'')+'px'

            if(width&&height){
                rightItems.push({content:`#{"type":"img","id":1,"src":"${src}","size":"big_match_image","width":"${width}","height":"${height}"}#`,id:i+1,style_type:0});
            }else{
                rightItems.push({content:`#{"type":"img","id":1,"src":"${src}","size":"big_match_image"}#`,id:i+1,style_type:0});
            }
        }else{
            let innerString
            if(hasdata){
                innerString = replaceCommonTags(items.rightLigature.content[i]);
            }else{
                innerString = replaceCommonTags(UM.getEditor(`ligature_right_${i+1}`).getContent());
            }
            if(!innerString){
                rightItems = false;
                return {leftItems:leftItems,rightItems:rightItems}
            }
            rightItems.push({content:innerString,id:i+1,style_type:1});
        }
    }
    return {leftItems:leftItems,rightItems:rightItems}
}

function getWordproblemContent(queue,style) {
    let content = [];
    queue.every(function (val,index) {
        if(val.indexOf('stem') > -1){
            let innerString = UM.getEditor(val).getContent();
            content.push(innerString);
        }else if (val.indexOf('imageAnswer') > -1) {
            let innerString = UM.getEditor(val).getContent();

            content.push(innerString);
        } else if (val.indexOf('answer') > -1) {

            let innerString = UM.getEditor(val).getContent();
            content.push(innerString);

        }else if (val.indexOf('explain') > -1) {
            let innerString = UM.getEditor(val).getContent()||'';
            content.push(innerString);
        }else if (val.indexOf('option') > -1) {
            let innerString = UM.getEditor(val).getContent();
            content.push(innerString);
        }else if (val == 1 || val == 0){//判断题
            content.push(val);
        }

        return true;
    });
    return content;
}




function replaceCommonTags(str,stemBlankIndex={stemBlankIndex:0}){
        // str = str.replace(/<p>(&nbsp;)*/g, '<p>').replace(/(&nbsp;)*<\/p>/g, '</p>')
        //     .replace(/<p>\s*<\/p>|<p>(<br\/?>)*<\/p>|<p>(&nbsp;)*<\/p>|<br\/?>*/g, '');
        // 问题1，出现<div></div>的情况（清空编辑器内容，把p标签给删除了～）
        str = str
            .replace(/<div>/ig,'<p>').replace(/<\/div>/ig, '</p>')
            .replace(/^<p>\s*<\/p>|^<p><\/p>|^<p>(<br\/>)*<\/p>/ig, '')
            .replace(/<p>\s*<\/p>$|<p><\/p>$|<p>(<br\/>)*<\/p>$/ig, '').replace(/<p>(<br\/>)*<\/p>/ig, '<p></p>').replace(/<br\/>/ig, '<p></p>')
            .replace(/&amp;/ig,'&');
    if(/^<p>/.exec(str)){str = str.slice(3)}
    if(/<\/p>$/.exec(str)){str = str.slice(0,-4)}
    str = str.replace(/<p>/g,'#{"type":"P"}#').replace(/<\/p>/g,'')
    let inner_span = str.match(/<span [^>]*>[\s\S]*?<\/span>/ig);
    inner_span && inner_span.map(val=>{
        if($(val).attr('class') && $(val).attr('class').indexOf('mathquill-embedded-latex')>-1){
            str = str.replace(val,`#{"type":"latex","content":"${$(val).text().replace('overline','dot').replace(/\\/g,'\\\\')}"}#‍`)
        }else if($(val).attr('style') && $(val).attr('style').indexOf('text-decoration:underline;')>-1){
            str = str.replace(val,`#{"type":"under_begin"}#${$(val).text()}#{"type":"under_end"}#`)
        }else if($(val).attr('class') && $(val).attr('class').indexOf('question-dot')>-1){
            let content = $(val).text().split('')
            let contentStr = ''
            content.forEach((d)=>{//把同一个dot分成两个
                contentStr += `#{"type":"latex","content":"\\\\dot{${d}}"}#‍`
            })
            str = str.replace(val,contentStr)

        }else if($(val).attr('class') && $(val).attr('class').indexOf('question-overline')>-1){
            let content = $(val).text()
            let contentStr = `#{"type":"latex","content":"\\\\overline{${content}}"}#‍`
            str = str.replace(val,contentStr)
			return 
        }else{
            // 问题2，出现丢题现象，<span>内容</span>，过滤掉了（折行又回去的场景）
            // str = str.replace(val,'')
        }
        
        
        return true;
    });


    let replaceBlank = 'blank—--fillin'
    let reg_blank = /\\\\left\[\\\\right\]/g;
    if (str.match(reg_blank)) {
        str.match(reg_blank).forEach(val => {
            str = str.replace(val, `\\\\#{\\"type\\":\\"blank\\",\\"id\\":\\"${replaceBlank}\\",\\"class\\":\\"fillin\\",\\"size\\":\\"express\\"}\\\\#`);
        });
    }
    let inner_img = str.match(/<img (.+?)\/>/ig);
    inner_img && inner_img.map((val,index)=>{
        let  width = $(val).attr('width')||false
        let  height = $(val).attr('height')||false
        if(width==='pxundefined'||width==='px0'){width=false}
        if(height==='pxundefined'||height==='px0'){height=false}

        width = width&&width.replace(/px/ig,'')+'px'
        height = height&&height.replace(/px/ig,'')+'px'
        switch ($(val).attr('class')){
            case 'img_fillin_line' :
                str = str.replace(val,`#{"type":"blank","id":"${replaceBlank}","class":"fillin","size":"line"}#‍`)
                break;
            case 'img_fillin_letter' :
                str = str.replace(val,`#{"type":"blank","id":"${replaceBlank}","class":"fillin","size":"letter"}#‍`)
                break;
            case 'img_fillin_equation' :
                str = str.replace(val,`#{"type":"blank","id":"${replaceBlank}","class":"fillin","size":"equation"}#‍`)
                break;
            case 'img_fillin_delivery' :
                str = str.replace(val,`#{"type":"blank","id":"${replaceBlank}","class":"fillin","size":"delivery_blank"}#‍`)
                break;
            case 'img_fillin_express' :
                str = str.replace(val,`#{"type":"blank","id":"${replaceBlank}","class":"fillin","size":"express"}#‍`)
                break;
            case 'img_fillin_multiline' :
                str = str.replace(val,`#{"type":"blank","id":"${replaceBlank}","class":"fillin","size":"multiline"}#‍`)
                break;

            case 'mis_smaller_image' :
                if(width&&height){
                    str = str.replace(val,`#{"type":"img","id":"1","src":"${$(val).attr('src')}","size":"small_image","width":"${width}","height":"${height}"}#‍`)

                }else{
                    str = str.replace(val,`#{"type":"img","id":"1","src":"${$(val).attr('src')}","size":"small_image"}#‍`)
                }
                break;
            case 'mis_middle_image' :

                if(width&&height){
                    str = str.replace(val,`#{"type":"img","id":"1","src":"${$(val).attr('src')}","size":"mid_image","width":"${width}","height":"${height}"}#‍`)
                }else{
                    str = str.replace(val,`#{"type":"img","id":"1","src":"${$(val).attr('src')}","size":"mid_image"}#‍`)
                }
                break;
            case 'mis_bigger_image' :
                if(width&&height){
                    str = str.replace(val,`#{"type":"img","id":"1","src":"${$(val).attr('src')}","size":"big_image","width":"${width}","height":"${height}"}#‍`)
                }else{
                    str = str.replace(val,`#{"type":"img","id":"1","src":"${$(val).attr('src')}","size":"big_image"}#‍`)
                }
                break;
            case 'mis_order_image' :
                if(width&&height){
                    str = str.replace(val,`#{"type":"img","id":"1","src":"${$(val).attr('src')}","size":"order_image","width":"${width}","height":"${height}"}#‍`)
                }else{
                    str = str.replace(val,`#{"type":"img","id":"1","src":"${$(val).attr('src')}","size":"order_image"}#‍`)
                }
                break;
            default:
                // str = str.replace(val,'')
                break
        }
        return true;
    })
    let inner_audio = str.match(/<audio [^>]*>[\s\S]*?<\/audio>/ig);
    inner_audio && inner_audio.map((val,index)=>{
        if($(val).attr('class')==='math_reading'){
            str = str.replace(val,`#{"type":"audio","src":"${$(val).attr('src')}","style":"${$(val).attr('class')}"}#‍`)
        }else{
            str = str.replace(val,`#{"type":"audio","src":"${$(val).attr('src')}"}#‍`)
        }
        return true;
    })


    //将临时的图空替换未blankid
    if(stemBlankIndex){
        str=str.replace(/blank—--fillin/ig,()=>{
            stemBlankIndex.stemBlankIndex+=1;
            return stemBlankIndex.stemBlankIndex
        })
    }

    //将分数的分子分母填空id互换
    let regRevertId = /(#{"type":"latex","content":"\\\\frac{\\\\#{\\"type\\":\\"blank\\",\\"id\\":)(\\"[\s\S]{1,2}\\",)(\\"class\\":\\"fillin\\",\\"size\\":\\"express\\"}\\\\#}{\\\\#{\\"type\\":\\"blank\\",\\"id\\":)(\\"[\s\S]{1,2}\\",)(\\"class\\":\\"fillin\\",\\"size\\":\\"express\\"}\\\\#}"}#)/g
    str=str.replace(regRevertId,"$1$4$3$2$5")
    //去掉转译符
    str = str.replace(/&nbsp;/ig,' ').replace(/&quot;/ig,'\"').replace(/&gt;/ig,'>').replace(/&lt;/ig,'<').replace(/&#39;/ig,'\'')
    // debugger
    str = str.replace(/<div.*?>/ig,'').replace(/<span.*?>/ig,'').replace(/<\/div>/ig,'').replace(/<\/span>/ig,'').replace(/\n/ig,'')


    return str
}
export {getContent,getContentClassify,getLigatureItems,getWordproblemContent,getContentForExplainTask,replaceCommonTags}


// WEBPACK FOOTER //
// ./src/utils/getEditorContent.js